export default {"src":"/_next/static/media/guide.c2b24c69.svg","height":40,"width":40};